__turbopack_context__.v({
  "button": "Button-module-scss-module__Bc5QGa__button",
  "button--primary": "Button-module-scss-module__Bc5QGa__button--primary",
  "button--secondary": "Button-module-scss-module__Bc5QGa__button--secondary",
  "button--tertiary": "Button-module-scss-module__Bc5QGa__button--tertiary",
  "button-wrapper": "Button-module-scss-module__Bc5QGa__button-wrapper",
  "button__arrow": "Button-module-scss-module__Bc5QGa__button__arrow",
  "button__arrow-wrapper": "Button-module-scss-module__Bc5QGa__button__arrow-wrapper",
});
